'use client'

import type { ReactNode } from 'react'

interface ContentInfoProps {
  children: ReactNode
  className?: string
}

export function ContentInfo({ children, className }: ContentInfoProps) {
  return (
    <footer id="contentinfo" className={className}>
      {children}
    </footer>
  )
}
